/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Logical operator to apply to the list of `operands`. `UNSPECIFIED` is supported only in responses. 
*/
export enum LogicalOperator {
  AND_OPERATOR = 'AND',
  OR_OPERATOR = 'OR',
  LOGICAL_OPERATOR_UNSPECIFIED = 'UNSPECIFIED'
}
